import React, { useEffect, useState } from "react";
import { fetchEmployeeListData } from "../../../Redux/features/EmployeeList/EmployeeListSlice";
import { useSelector, useDispatch } from "react-redux";
import "../../../Styles/EmployeeList/employeeList.css";
import { useAuthDetails } from "../../../Common/cookiesHelper";
import { Grid } from "@mui/material";

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { SortTableItemsHelperFun } from "../../../helperFunctions/SortTableItemsHelperFun";
import sortIcon from "../../../Assests/Category/SortingW.svg";
import { SkeletonTable } from "../../../reuseableComponents/SkeletonTable";
import CustomHeader from "../../../reuseableComponents/CustomHeader";
import NoDataFound from "../../../reuseableComponents/NoDataFound";
import InputTextSearch from "../../../reuseableComponents/InputTextSearch";
import HoverInfoLogo from "../../../reuseableComponents/HoverInfoLogo";
import { updateReportPayload } from "../../../Redux/features/Reports/SalesReport/SalesReportSlice";
import { formatPhoneNumber } from "../../../helperFunctions/formatPhoneNumber";
import PasswordShow from "../../../Common/passwordShow";
const StyledTable = styled(Table)(({ theme }) => ({
  padding: 2, // Adjust padding as needed
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--qv-bg-253338, #253338)",
    color: theme.palette.common.white,
    fontFamily: "CircularSTDMedium !important",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "CircularSTDBook !important",
  },
  [`&.${tableCellClasses.table}`]: {
    fontSize: 14,
    fontFamily: "CircularSTDBook !important",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {},
  "& td, & th": {
    border: "none",
  },
}));

const EmployeelistReport = ({
  hide,
  setCSVData,
  setCSVHeader,
  setCSVFileName,
}) => {
  const [employeeData, setAllEmployeeData] = useState([]);
  const [employeeDataFilter, setEmployeeDataFilter] = useState([]);
  const { LoginGetDashBoardRecordJson, LoginAllStore, userTypeData } =
    useAuthDetails();
  const [searchRecord, setSearchRecord] = useState("");

  const AllEmployeeListState = useSelector((state) => state.employeeDataList);
  const dispatch = useDispatch();
  const { handleApiError } = PasswordShow();
  let merchant_id = LoginGetDashBoardRecordJson?.data?.merchant_id;
  const tableRow = [
    { name: "employee_name", label: "Employee Name" },
    // { name: "pin", label: "PIN" },
    { name: "contact", label: "Contact" },
    { name: "email", label: "Email" },
    { name: "address", label: "Address" },
  ];
  useEffect(() => {
    const fetchData = async () => {
      let data = {
        merchant_id,
        ...userTypeData,
      };

      if (!merchant_id) return;
      try {
        dispatch(updateReportPayload(data));
        await dispatch(fetchEmployeeListData(data)).unwrap();
      } catch (error) {
        handleApiError(
          error,
          error?.message || "Failed to fetch employee list",
        );
      }
    };

    fetchData();
  }, [dispatch, merchant_id]);

  useEffect(() => {
    if (AllEmployeeListState.loading) return;

    const list = Array.isArray(AllEmployeeListState.employeeListData)
      ? AllEmployeeListState.employeeListData
      : [];

    const updatedData = list.map((data) => {
      const fullName = `${data?.f_name ? data.f_name : ""} ${
        data?.l_name ? data.l_name : ""
      }`.trim();
      return { ...data, fullName };
    });

    setAllEmployeeData(updatedData);
    setEmployeeDataFilter(updatedData);
    getExportData(updatedData);
  }, [AllEmployeeListState.loading, AllEmployeeListState.employeeListData]);
  // ===============
  const getExportData = (employeeList) => {
    if (employeeList.length > 0) {
      setCSVFileName("employee_directory");
      setCSVHeader(
        tableRow?.map((row) => ({ label: row.label, key: row.name }))
      );

      const formattedData =
        employeeList.length > 0
          ? employeeList.map((result) => {
              return {
                employee_name: result?.fullName ? result.fullName : "-",
                pin: !!result?.pin ? result.pin : "-",
                contact: !!result?.phone
                  ? formatPhoneNumber(result.phone)
                  : "-",
                email: !!result?.email ? result.email : "-",
                address: [
                  !!result?.address ? result?.address : "",
                  !!result?.city ? result?.city : "",
                  !!result?.state ? result?.state : "",
                  !!result?.zipcode ? result?.zipcode : "",
                ]
                  .filter(Boolean) // Remove falsy values
                  .join(", "), // Join with a comma and space
              };
            })
          : [];
      setCSVData(formattedData);
    } else {
      setCSVHeader([]);
      setCSVData([]);
      setCSVFileName("");
    }
  };
  // ===============

  const [sortOrder, setSortOrder] = useState("asc");
  const sortByItemName = (type, name) => {
    const { sortedItems, newOrder } = SortTableItemsHelperFun(
      employeeData,
      type,
      name,
      sortOrder
    );
    setAllEmployeeData(sortedItems);
    setSortOrder(newOrder);
  };
  const handleSearchInputChange = (value) => {
    setSearchRecord(value);
    let data = employeeDataFilter.filter((employeeByName) =>
      (
        (employeeByName?.fullName?.toLowerCase() || "") +
        (employeeByName?.phone?.toLowerCase() || "") +
        (employeeByName?.email?.toLowerCase() || "")
      ).includes(value.toLowerCase())
    );
    setAllEmployeeData(data);
  };

  const handleKeyDown = (e) => {
    handleSearchInputChange(e.target.value);
    if (e.key === "Enter") {
      e.target.blur();
    }
  };
  return (
    <>
      <Grid
        container
        className="box_shadow_div"
        sx={{ mt: `${hide ? 0 : 2.5}`, py: 2.5 }}
      >
        <Grid item xs={12} sx={{ px: { xs: 1, sm: 2.5 } }}>
          <InputTextSearch
            className=""
            type="text"
            value={searchRecord}
            handleChange={handleSearchInputChange}
            placeholder="Search by Employee Name"
            autoComplete="off"
            handlefocus={handleKeyDown}
          />
        </Grid>
      </Grid>
      <Grid
        container
        sx={{ mt: `${hide ? 0 : 2.5}` }}
        className="box_shadow_div"
      >
        {!hide ? <CustomHeader>Employee List </CustomHeader> : ""}
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              {AllEmployeeListState.loading ? (
                <SkeletonTable
                  columns={[
                    "Employee Name",
                    // "PIN",
                    "Contact",
                    "Email",
                    "Address",
                  ]}
                />
              ) : (
                <TableContainer
                  className="custom-scroll-hidden"
                  sx={{ maxHeight: "80vh" }}
                >
                  <StyledTable
                    stickyHeader
                    sx={{ minWidth: 700 }}
                    aria-label="customized table"
                  >
                    <TableHead>
                      <StyledTableCell>
                        <button
                          className="flex items-center"
                          onClick={() => sortByItemName("str", "fullName")}
                        >
                          <p className="whitespace-nowrap">Name</p>
                          <HoverInfoLogo
                            title={"The full name of the employee."}
                          />
                          <img src={sortIcon} alt="" className="pl-1" />
                        </button>
                      </StyledTableCell>
                      {/* <StyledTableCell>
                        <button
                          className="flex items-center"
                          onClick={() => sortByItemName("num", "pin")}
                        >
                          <p>PIN</p>
                          <HoverInfoLogo
                            title={
                              "Unique code used by the employee to access the POS system."
                            }
                          />
                          <img src={sortIcon} alt="" className="pl-1" />
                        </button>
                      </StyledTableCell> */}
                      <StyledTableCell>
                        <div className="flex items-center">
                          <p>Contact</p>
                          <HoverInfoLogo
                            title={"The contact number for this employee."}
                          />
                        </div>
                      </StyledTableCell>
                      <StyledTableCell>
                        <button
                          className="flex items-center"
                          onClick={() => sortByItemName("str", "email")}
                        >
                          <p>Email</p>
                          <HoverInfoLogo
                            title={"The registered email of the employee"}
                          />
                          <img src={sortIcon} alt="" className="pl-1" />
                        </button>
                      </StyledTableCell>
                      <StyledTableCell>
                        <div className="flex items-center">
                          <p>Address</p>
                          <HoverInfoLogo
                            title={
                              "The employee's current regidential address on file."
                            }
                          />
                        </div>
                      </StyledTableCell>
                    </TableHead>
                    <TableBody>
                      {employeeData && employeeData?.length >= 1
                        ? employeeData?.map((employee, index) => (
                            <StyledTableRow key={index}>
                              <StyledTableCell>
                                <p>{employee?.fullName}</p>
                              </StyledTableCell>
                              {/* <StyledTableCell>
                                <p>{employee?.pin}</p>
                              </StyledTableCell> */}
                              <StyledTableCell>
                                <p>{formatPhoneNumber(employee?.phone)}</p>
                              </StyledTableCell>
                              <StyledTableCell>
                                <p>{employee?.email}</p>
                              </StyledTableCell>
                              <StyledTableCell>
                                <p>
                                  {" "}
                                  {employee
                                    ? [
                                        employee.address,
                                        employee.city,
                                        employee.state,
                                        employee.zipcode,
                                      ]
                                        .filter(Boolean)
                                        .join(", ")
                                    : ""}
                                </p>
                              </StyledTableCell>
                            </StyledTableRow>
                          ))
                        : ""}
                    </TableBody>
                  </StyledTable>
                  {!employeeData?.length && <NoDataFound />}
                </TableContainer>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default EmployeelistReport;
